var _style, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 278.9",
    style: {
      enableBackground: "new 0 0 595.3 278.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6A421;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.85;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#CBCCCE;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.9,221.2c0,0,80.1,63.3,148.5,1.3c0,0,7.4-0.1,2.4,6.4c-5,6.5-22.9,28.1-55.8,34.7 c-32.9,6.6-73.5-12.7-90.7-32.2C138.4,231.3,125.9,219.3,133.9,221.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -157.6541,
    y1: 796.5621,
    x2: -126.96,
    y2: 796.5621,
    gradientTransform: "matrix(0.9007 -0.4344 0.4344 0.9007 76.2178 -572.0659)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3EAC4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88C541"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.9,183c0,0,3.4,1.4-8.3,16.3c-11.7,14.8-1.5,24.1-1.5,24.1s13.9-12.5,10.7-30.9c0,0,6.5,10.9-0.7,21.7 c-6.6,9.9-10,13.1-9,17.8c0,0,2-6.2,7.5-10.3s11.7-15.7,7.6-27.8C300.1,181.9,297.9,183,297.9,183z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 26.6,
    className: "st3",
    width: 21.4,
    height: 182.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.4,75.8c-18.7,0-33,8.2-42.9,24.7H102V78.9H81.1v130.6H102V135c0-12,3.4-21.9,10.3-29.8 c6.8-7.9,15.5-11.8,26-11.8c20.2,0,30.4,13.9,30.4,41.6v74.5h20.9v-79.8c0-17.4-3.8-30.8-11.4-40C170.6,80.4,159.7,75.8,145.4,75.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.2,75.8c-18.7,0-33,8.2-42.9,24.7h-0.5V78.9h-20.9v130.6h20.9V135c0-12,3.4-21.9,10.3-29.8 c6.8-7.9,15.5-11.8,26-11.8c20.2,0,30.4,13.9,30.4,41.6v74.5h20.9v-79.8c0-17.4-3.8-30.8-11.4-40C318.4,80.4,307.5,75.8,293.2,75.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M404.5,40.2L383.5,47v31.9h-22.4v17.9h22.4V174c0,25.5,11.4,38.3,34.3,38.3c8.1,0,14.6-1.4,19.5-4.1v-17.9 c-3.8,2.9-8.4,4.3-13.6,4.3c-6.9,0-11.8-1.9-14.8-5.6c-3-3.7-4.5-10-4.5-18.8V96.7h32.9V78.9h-32.9V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M566.8,45.7c3.8,0,7.1-1.3,9.8-4c2.7-2.6,4-5.8,4-9.6c0-3.9-1.3-7.2-4-9.8c-2.7-2.6-5.9-3.9-9.8-3.9 c-3.7,0-6.9,1.3-9.6,3.9c-2.6,2.6-4,5.8-4,9.8c0,3.9,1.3,7.1,4,9.7C559.9,44.4,563.1,45.7,566.8,45.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.1,
    y: 78.9,
    className: "st3",
    width: 20.9,
    height: 130.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M541.4,65.8c0,0,1.9,4.7-23.8,7.7c-25.7,3-24.8,21.9-24.8,21.9s25.6,1.4,40.2-19.6c0,0-4.2,16.9-21.7,20.4 c-10.3,2.1-16.6,2.7-20.8,4.4c-1.7,0.2-3.1,0.3-4.5,0.3v-22h-20.7v130.6v0.5H486v-0.5h0.2v-42.7H486v-54.7 c2.3-9.9,12.7-10.3,16.5-10.1c9.2,1.3,26.5-4,34.2-19.5C544.5,66.9,541.4,65.8,541.4,65.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.7,258.6h-6.9v-13.2c0-2.8-0.1-4.6-0.4-5.4c-0.3-0.8-0.8-1.5-1.4-1.9c-0.7-0.5-1.5-0.7-2.4-0.7 c-1.2,0-2.3,0.3-3.2,1c-0.9,0.7-1.6,1.5-1.9,2.6c-0.4,1.1-0.5,3.1-0.5,6v11.7h-6.9v-25.9h6.4v3.8c2.3-2.9,5.1-4.4,8.5-4.4 c1.5,0,2.9,0.3,4.2,0.8c1.3,0.5,2.2,1.2,2.8,2.1c0.6,0.8,1.1,1.8,1.3,2.9c0.3,1.1,0.4,2.6,0.4,4.6V258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M385.9,252.2v6.4h-24c0.3-2.4,1-4.7,2.3-6.8c1.3-2.2,3.9-5,7.7-8.6c3.1-2.9,5-4.8,5.7-5.9 c0.9-1.4,1.4-2.8,1.4-4.2c0-1.5-0.4-2.7-1.2-3.5c-0.8-0.8-2-1.2-3.4-1.2c-1.4,0-2.6,0.4-3.4,1.3c-0.8,0.9-1.3,2.3-1.5,4.3 l-6.8-0.7c0.4-3.8,1.7-6.5,3.8-8.1c2.1-1.6,4.8-2.5,8.1-2.5c3.5,0,6.3,1,8.3,2.9c2,1.9,3,4.3,3,7.1c0,1.6-0.3,3.1-0.9,4.6 c-0.6,1.5-1.5,3-2.7,4.6c-0.8,1.1-2.3,2.6-4.5,4.6c-2.2,2-3.5,3.3-4.1,4c-0.6,0.7-1,1.3-1.4,1.9H385.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.1,258.6h-6.9v-13.2c0-2.8-0.1-4.6-0.4-5.4c-0.3-0.8-0.8-1.5-1.4-1.9c-0.7-0.5-1.5-0.7-2.4-0.7 c-1.2,0-2.3,0.3-3.2,1c-0.9,0.7-1.6,1.5-1.9,2.6c-0.4,1.1-0.5,3.1-0.5,6v11.7h-6.9v-25.9h6.4v3.8c2.3-2.9,5.1-4.4,8.5-4.4 c1.5,0,2.9,0.3,4.2,0.8c1.3,0.5,2.2,1.2,2.8,2.1c0.6,0.8,1.1,1.8,1.3,2.9c0.3,1.1,0.4,2.6,0.4,4.6V258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M459.8,258.6v-35.5h7.2v29.5h18v6H459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M513.7,240.5l-6.2-1.1c0.7-2.5,1.9-4.4,3.6-5.6c1.7-1.2,4.2-1.8,7.6-1.8c3.1,0,5.3,0.4,6.8,1.1 c1.5,0.7,2.6,1.6,3.2,2.8c0.6,1.1,0.9,3.2,0.9,6.1l-0.1,8c0,2.3,0.1,4,0.3,5c0.2,1.1,0.6,2.2,1.2,3.5h-6.8c-0.2-0.5-0.4-1.1-0.7-2 c-0.1-0.4-0.2-0.7-0.2-0.8c-1.2,1.1-2.4,2-3.8,2.6c-1.3,0.6-2.8,0.9-4.3,0.9c-2.7,0-4.8-0.7-6.3-2.2c-1.5-1.4-2.3-3.3-2.3-5.5 c0-1.5,0.3-2.8,1-3.9c0.7-1.1,1.7-2,2.9-2.6c1.3-0.6,3.1-1.1,5.5-1.6c3.2-0.6,5.4-1.2,6.7-1.7V241c0-1.3-0.3-2.3-1-2.8 c-0.7-0.6-1.9-0.8-3.7-0.8c-1.2,0-2.2,0.2-2.9,0.7C514.7,238.5,514.1,239.3,513.7,240.5z M522.9,246.1c-0.9,0.3-2.3,0.6-4.2,1 c-1.9,0.4-3.1,0.8-3.7,1.2c-0.9,0.6-1.3,1.4-1.3,2.4c0,1,0.4,1.8,1.1,2.5c0.7,0.7,1.6,1,2.7,1c1.2,0,2.4-0.4,3.5-1.2 c0.8-0.6,1.4-1.4,1.6-2.3c0.2-0.6,0.3-1.7,0.3-3.3V246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M554.6,258.6v-35.8h6.9v12.9c2.1-2.4,4.6-3.6,7.5-3.6c3.2,0,5.8,1.1,7.8,3.4c2.1,2.3,3.1,5.6,3.1,9.9 c0,4.4-1.1,7.8-3.2,10.2c-2.1,2.4-4.7,3.6-7.7,3.6c-1.5,0-2.9-0.4-4.4-1.1c-1.4-0.7-2.7-1.8-3.7-3.3v3.8H554.6z M561.4,245 c0,2.7,0.4,4.7,1.3,6c1.2,1.8,2.8,2.7,4.7,2.7c1.5,0,2.8-0.6,3.9-1.9c1.1-1.3,1.6-3.3,1.6-6.1c0-3-0.5-5.1-1.6-6.4 c-1.1-1.3-2.5-2-4.1-2c-1.6,0-3,0.6-4.1,1.9C561.9,240.5,561.4,242.4,561.4,245z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0915269018196cc94ff401b302c0f694.svg";
export { ForwardRef as ReactComponent };